import styled from 'styled-components';
import { VerticalSeparator as Separator } from '../Commons/Separators/styles';

export const Container = styled.div`
  display: flex;
  margin-right: 1.5rem;
  align-items: center;
  color: ${({ theme }) => theme.colors.grayDark4};
  gap: 0.5rem;

  & > span.title {
    margin-bottom: unset;
    display: flex;
    align-items: center;
    font-size: 1rem;
  }

  & > span.description {
    font-weight: 600;
    font-size: 0.875rem;
  }
`;

export const VerticalSeparator = styled(Separator)`
  opacity: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    opacity: 1;
    margin-right: 1.5rem;
  }
`;

export const CreditDetailsLink = styled.a`
  font-size: 0.75rem;
`;

export const CollorFulBall = styled.span`
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 5px;
  margin-left: 0.5rem;
`;
